import {AfterViewInit, Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from '../i18n/pl';
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {User} from "../../../models";
import {Observable, of} from "rxjs";
import {catchError, debounceTime, first, map, startWith, switchMap} from "rxjs/operators";
import {Items} from "../../../models/items";
import {AccountService, AlertService, UserService} from "../../../services";
import {Country} from "../../../models/country";
import {CountryService} from "../../../services/country.service";
import {Order} from "../../../models/order";



@Component({
    selector: 'select-customer-dialog',
    templateUrl: './selectCustomerDialog.component.html',
    styleUrls: ['./selectCustomerDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class SelectCustomerDialogComponent implements AfterViewInit{
    action: string;
    dialogTitle: string;
    dialogRef: any;
    editMode: boolean = false;
    form: FormGroup;
    filteredOptions: Observable<User[]>;
    customers: User[];
    workers: User[];
    countries: Country[];
    order: Order;

    constructor(
        public matDialogRef: MatDialogRef<SelectCustomerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
        private userService: UserService,
        private alertService: AlertService,
        private formBuilder: FormBuilder,
        private countryService: CountryService,
        private accountService: AccountService,
    ) {
        // this.product = _data.product;
        this.translationLoader.loadTranslations(polish);

        this.order = _data.order;
        let wantInvoice = !!this.order.nip;

        this.form = this.formBuilder.group({
            customer: [this.order.customer],
            worker: [this.order.worker, Validators.required],
            invoice: [wantInvoice],
            nip: [this.order.nip],
            companyName: [this.order.companyName],
            companyStreet: [this.order.companyStreet],
            companyPostCode: [this.order.companyPostCode],
            companyCity: [this.order.companyCity],
            companyCountry: [this.order.companyCountry],
        });

        this.userService.getAllWorkers().pipe(first()).subscribe((res: Items) => {
                this.workers = res.items;
            },
            error => {
                this.alertService.error(error);
            });

        this.userService.getAllCustomers().subscribe((res: Items)=>{
            this.customers = res.items;
            this.filteredOptions = this.form.get('customer').valueChanges
                .pipe(
                    startWith(''),
                    debounceTime(300),
                    switchMap(value => {
                        if (value !== '') {
                            return this.lookup(value);
                        } else {
                            return of(null);
                        }
                    })
                );
        }, error => {

        });

        this.countryService.getAll().subscribe((res: any[]) => {
            this.countries = res;

            if (!this.order.companyCountry) {
                for (let i=0; i < this.countries.length; i++) {
                    if (this.countries[i].iso2 === 'PL') {
                        this.order.companyCountry = this.countries[i].id;
                        this.form.get('companyCountry').setValue(this.order.companyCountry);
                        break;
                    }
                }
            }
        }, error => {
            this.alertService.error(error);
        });

        if (!this.order.worker) {
            this.accountService.getCurrentAccount().pipe(first()).subscribe((user: User) => {
                this.form.get('worker').setValue(user.id);
            }, error => {
                this.alertService.error(error);
            });
        }
    }

    ngAfterViewInit() {
    }

    lookup(value: string): Observable<Items> {
        return this.userService.getAllCustomersBy(value).pipe(
            // map the item property of the github results as our return object
            map(results => results.items),
            // catch errors
            catchError(_ => {
                return of(null);
            })
        );
    }

    displayFn(userId: User): string {
        return (userId)? userId.firstName + ' ' + userId.lastName + '; ' + userId.phone: '';
    }

    get f() {
        return this.form.controls;
    }

    requireInvoice = false;

    public wantInvoice(event) {
        if (!event.checked) {
            this.f.nip.setValue("");
            this.f.companyName.setValue("");
            this.f.companyStreet.setValue("");
            this.f.companyPostCode.setValue("");
            this.f.companyCity.setValue("");
            this.f.companyCountry.setValue("");

            this.f.nip.clearValidators();
            this.f.nip.updateValueAndValidity();
            this.requireInvoice = false;
        } else {
            let customerId = this.f.customer.value;

            this.f.nip.setValidators(Validators.required);
            this.f.nip.updateValueAndValidity();
            this.requireInvoice = true;

            if (this.customers) {
                for (let i = 0; i < this.customers.length; i++) {
                    if (this.customers[i].id !== customerId) {
                        continue;
                    }

                    this.f.nip.setValue(this.customers[i].nip);
                    this.f.companyName.setValue(this.customers[i].companyName);
                    this.f.companyStreet.setValue(this.customers[i].companyStreet);
                    this.f.companyPostCode.setValue(this.customers[i].companyPostCode);
                    this.f.companyCity.setValue(this.customers[i].companyCity);
                    this.f.companyCountry.setValue(this.customers[i].companyCountry);
                }
            }
        }
    }
}
